import device from 'current-device';
import { isJSON, getParamType } from '@/libs/global';

function setupIOSCallback (callback) {
  if (window.WKWebViewJavascriptBridge) {
    return callback(window.WKWebViewJavascriptBridge);
  }

  if (window.WKWVJBCallbacks) {
    return window.WKWVJBCallbacks.push(callback);
  }

  window.WKWVJBCallbacks = [callback];
  window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null);
}

export default async function (event, iosContent = {}, aosContent) {
  if (device.ios()) {
    let iosVariable = iosContent;

    if (getParamType(iosContent) === 'Object') {
      iosVariable = [iosContent];
    }

    return new Promise((resolve, reject) => {
      setupIOSCallback((evt) => {
        evt.callHandler(event, ...iosVariable, (res) => {
          resolve(res);
        });
      });
    });
  } else if (device.android()) {
    let aosVariable = aosContent;

    if (getParamType(aosContent) === 'String') {
      aosVariable = [aosContent];
    }

    return new Promise((resolve, reject) => {
      let fn = '';

      if (aosContent !== undefined) {
        fn = window.pxPlusWeb[event](...aosVariable);
      } else {
        fn = window.pxPlusWeb[event]();
      }

      if (isJSON(fn)) fn = JSON.parse(fn);

      resolve(fn);
    });
  } else {
    return new Promise((resolve, reject) => {
      switch (event) {
      case 'getHeaderData':
        // resolve({
        //   device_id: '04D806D1-4AA5-4BEE-A2EA-160FBE4D8A381',
        //   platform_id: 'c155bc3c30ab453db6766c662eb6a919',
        //   app_version: 'AOS-11_1.0.0_1.0.0',
        //   client_id: 'a5470c29240646eba77e3a498bca70bc',
        //   authentication: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRfaWQiOiJpX2FtX21lbWJlcl9jb2RlIiwic2Nvc
        // GUiO' +
        //   'iJHdWVzdCwgQXBwbHksIEF1dGhvcml6ZWQiLCJjdXN0IjoiSTk4SlFLdW1jZXNQRHEzaUdiR083S0NHM1cxVGpTVmt' +
        //   'yM0gzS3hDM25sN3BrMmNuNGt4ZFJPMUFIOVY0ZVU4dSIsImp0aSI6ImVkY2U2ODhmNzQyZTQwMTU4ODNlNTNhZmRkZ' +
        //   'TcxMTJmIiwiZXhwIjoxNjMxNjQzMDg5LCJpYXQiOjE2MzEwMzgyODksImlzcyI6IlB4UGx1cyIsImF1ZCI6IlBYUGF' +
        //   '5In0.y_XUdyM6h5vgEgkn31qFtTwTz4OnBVQ6qWi3oNLVPpw'
        // });
        resolve({
          authentication: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRfaWQiOiJpX2FtX21lbWJlcl9jb2RlIi' +
          'wic2NvcGUiOiJHdWVzdCwgQXBwbHksIEF1dGhvcml6ZWQiLCJjdXN0IjoiWm52NVpQUTlBNXJ6dzBJdFZmdHIvaDhzMW1kcm' +
          'hqT0ZJQlRaUFB3aGc1QUNKdThobE9ORmNQSjVzeUV2OVJ2ZiIsImp0aSI6ImZjNzIyYzllNGM3MTRkMzU5MmZhODRjZDM4Nzd' +
          'kMjNlIiwiZXhwIjoxNjMzNjA1NTg3LCJpYXQiOjE2MzMwMDA3ODcsImlzcyI6IlB4UGx1cyIsImF1ZCI6IlBYUGF5In0.9Q7B' +
          '8E15oK0wK73lHppji2WVO9LZxqKBWKbu8K3KUDk',
          platform_id: 'c155bc3c30ab453db6766c662eb6a919',
          device_id: '04D806D1-4AA5-4BEE-A2EA-160FBE4D8A381',
          app_version: 'AOS-11_1.0.0_1.0.0',
          client_id: 'i_am_member_code',
          timestamp: '1624606632',
          'x-request-id': 'a5470c29240646eba77e3a498bca70bc'
        });
        break;

      case 'openExternalLink':
        resolve('open link');
        break;

      case 'setBarColor':
        resolve('set color');
        break;

      case 'closeWebView':
        resolve('close web view');
        break;

      default:
        resolve('ios function');
      }
    });
  }
}
